import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPublicOpportunity, formatApiError } from "../lib/api";
import { OpportunityIntelligence } from "../components/OpportunityIntelligence";
import { Button } from "../components/ui/button";
import { LOGO_NAV } from "../lib/vehicleImages";

export default function PublicReport() {
  const { token } = useParams();
  const [opp, setOpp] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => document.head.removeChild(m);
  }, []);

  useEffect(() => {
    getPublicOpportunity(token)
      .then((d) => setOpp(d.opportunity))
      .catch((e) => setErr(formatApiError(e?.response?.data?.detail) || "This report is not available."));
  }, [token]);

  return (
    <div className="max-w-[1100px] mx-auto px-5 md:px-8 py-10" data-testid="public-report">
      <div className="flex items-center justify-between gap-4 mb-8 pb-6 border-b border-slate-200 no-print">
        <div className="flex items-center gap-3">
          <img src={LOGO_NAV} alt="Atlas" className="h-8 w-auto" />
          <div>
            <div className="text-[11px] uppercase tracking-widest text-slate-400 font-mono">Atlas Opportunity Report</div>
            <div className="text-sm text-slate-500">Shared acquisition intelligence</div>
          </div>
        </div>
        {opp && (
          <Button variant="outline" className="h-9" onClick={() => window.print()} data-testid="public-report-pdf">Download PDF</Button>
        )}
      </div>

      {err ? (
        <div className="py-20 text-center text-slate-400" data-testid="public-report-error">{err}</div>
      ) : !opp ? (
        <div className="py-20 text-center text-slate-400">Loading report…</div>
      ) : (
        <div data-testid="public-report-body" className="print-area">
          <div className="hidden print:block mb-5">
            <span className="text-[11px] uppercase tracking-widest text-slate-400 font-mono">Atlas Opportunity Report</span>
          </div>
          {opp.preparedBy && (
            <p className="text-xs text-slate-500 mb-4" data-testid="public-report-prepared-by">
              Prepared by {opp.preparedBy}
            </p>
          )}
          <OpportunityIntelligence data={opp} />
          <p className="text-[11px] text-slate-400 mt-6">
            Atlas provides acquisition intelligence, not the transaction. Figures are calculated from
            operator-entered data and real ECB FX rates; verify assumptions before purchase.
            {opp.createdAt ? ` Prepared ${new Date(opp.createdAt).toLocaleDateString()}.` : ""}
          </p>
        </div>
      )}
    </div>
  );
}
